import { render, staticRenderFns } from "./VideoPlayer.vue?vue&type=template&id=ab5dd12a&scoped=true&"
import script from "./VideoPlayer.vue?vue&type=script&lang=js&"
export * from "./VideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlayer.vue?vue&type=style&index=0&id=ab5dd12a&prod&lang=scss&"
import style1 from "./VideoPlayer.vue?vue&type=style&index=1&id=ab5dd12a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5dd12a",
  null
  
)

export default component.exports